import PosthogService from '~/services/posthog/PosthogService';
import { fireAccountSendFeedbackClicked } from '~/posthogs/events';

/**
 * PostHog "Platform Feedback Survey" — the single survey behind every
 * Send Feedback entry point (dental portal, office mobile, professional).
 *
 * The id is also hard-coded in `src/index.css`, which draws the scrim behind
 * this survey. CSS cannot import, so the two have to be kept in step: if the
 * survey is ever recreated in PostHog, both need the new id.
 */
export const PLATFORM_FEEDBACK_SURVEY_ID =
  '019fa633-425f-0000-2b2a-d671f42ee774';

/**
 * Opens the feedback survey from the Account menu.
 *
 * Fires the click event the survey is configured to trigger on, then shows the
 * survey straight away instead of waiting for the SDK's once-a-second display
 * loop to notice the event. The event still matters on its own: it is what
 * mobile triggers on, and it is the fallback here if surveys have not loaded
 * yet when the row is clicked.
 */
export function openPlatformFeedbackSurvey(): void {
  fireAccountSendFeedbackClicked();
  PosthogService.getInstance().displaySurvey(PLATFORM_FEEDBACK_SURVEY_ID);
}
